import React from "react";
import "./SideBarLeft.css";
import { makeStyles, Tab, TabList, Image,Tooltip } from "@fluentui/react-components";
import crm from "../../assets/images/CRM-2.svg";
import calender from "../../assets/images/Calendar.svg";
import cmail from "../../assets/images/Email.svg";
import accounting from "../../assets/images/Accounting.svg";
import retail from "../../assets/images/Retail.svg";
import finance from "../../assets/images/Finance.svg";
import critics from "../../assets/images/Critics.svg";
import settings from "../../assets/images/Settings.svg";
import { Board24Color } from "@fluentui/react-icons";
var TodoIcons = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL1SURBVHgB7VVPaxNBFH8zidHWViNoUpHWePGcD6DQiBSqIlUEqxcdBEFE/AhZP4FfYUHEQlEqBf8cdAsF8daeRFCwR2+phPqn7b7xzezOZrLZZJOaXCQPktnd2Znfn/fmLcAw/ve47v18OL+y9W1+9Vc1aZ7BAOPau60qATiMA3CFlOHOwtmRR/Y7HAYUV9/Wq9KXjpQSJALQAOCjE3diIA5cfl2v8kg5AzXSQCNrcaLvDlxarlfBUo40YuiAvqef7URfHbjwsk45R4eRXK5Ua+WsSb0ao5qQWMkmbXTsplfOwO4cYNb9vlDZ6AZ85vkPyrnvhDuTUqbVcSYDNKRnigRK/T4SK8nYJksC5ww9Wpen2w1aVUkjcX6xRjlnTqCU8HhcdehEOOpnEsTizJjLOoCb6Eji3LNalfZ04vZGgIaENU9z4gWBq/UsBbwjiemnBA7SacmxccJSbU4C51wszQbgEYEU8EQSZ57UdMFx1qywyXIWpsPcZ0AsXzzk2puyiXmvJDO4lgLeRKI0W77FNXioKkYiAG4oV/MZQLF85Ygb3zBLZTndJbiK0uHTxTWJmMcweaqRIKjKZkFTwaDq1ZkHLlW5A2ZQvEoA1+t/5/iSBLYOXcT4qSKMTRXyqrmoxoIY4OnrpoYj9XM9z6R40wYcIKyB/G0vv39besS73O7Fg6UijJcmoGF747gp5cZ2XXgQXAND8f7GURc6hHZt061s/smxSjsnRk8WYXSqCKq9NhQrhbLhAhhHZHC9mw4eOWAiyYkDk0UYIQKcASQVXaITKMWqSAePHDARdyJH4LnJQkOxnW/biTD/qu4k+l2DtxCIk9h3ohABtCNhik2lB3xffBAFF3qIxM+xIeFv767bKm0S8Wf0Lz7e6Q1cRcfPcelxLc/4jkcpLkf5Nh3OrgE6aut3ewdPJWCTILAyTyBBHohP9/YG3hUBm0TcCYIXn+/vHbxrAkkkqMeLL/8I3hMBQwJgZy6b9Te+Pji+AsMYRh/iL5mvmIzqBzX8AAAAAElFTkSuQmCC";

interface Props {
    handleTabClick: (tab: string) => void;
}

const SideBar: React.FC<Props> = ({handleTabClick}) => {

    return (
        <div className="QVF0n yck3y">
            <div className="fui-FluentProvider fui-FluentProviderr1 ___jdtuxv0 __GWY27H f19n0e5 fxugw4r f1o700av fk6fouc fkhj508 figsok6 f1i3iumi">
                <TabList className="__TBEK573=="  vertical>
                <Tab value="email"
                onClick={() => handleTabClick('email')}>
                    <Tooltip
                        withArrow
                        positioning="after"
                        content="Business email"
                        relationship="label">
                        <div>
                        <Image src={cmail} alt="Email Icon" width={22} height={22} />
                        </div>
                    </Tooltip>
                    </Tab>
                <Tab value="CRM"
                onClick={() => handleTabClick('CRM')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="CRM"
                        relationship="label">
                        <div>
                        <Image src={crm} alt="CRM Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>              
                </Tab>
                <Tab value="Calender"
                onClick={() => handleTabClick('Calender')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Calender"
                        relationship="label">
                        <div>
                        <Image src={calender} alt="Calender Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>             
                </Tab>
                <Tab value="Accounting"
                onClick={() => handleTabClick('Accounting')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Accounting"
                        relationship="label">
                        <div>
                        {/* <Image src={accounting} alt="Accounting Icon" width={22} height={22} />  */}
                        <Board24Color />
                        </div>
                    </Tooltip>    
                  
                </Tab>
                <Tab value="Retail"
                onClick={() => handleTabClick('Retail')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Retail and Requisitions"
                        relationship="label">
                        <div>
                        <Image src={retail} alt="Retail Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>                  
                </Tab>

                <Tab value="Finance"
                onClick={() => handleTabClick('Finance')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Manage Finance"
                        relationship="label">
                        <div>
                        <Image src={finance} alt="Finance Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>            
                </Tab>
                {/* <Tab value="Todo"
                 onClick={() => handleTabClick('Todo')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Manage todo List"
                        relationship="label">
                        <div>
                        <Image src={TodoIcons} alt="Todo Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>    
                   
                </Tab> */}
                 <Tab value="settings"
                  onClick={() => handleTabClick('settings')}>
                <Tooltip
                        withArrow
                        positioning="after"
                        content="Setup your work flow"
                        relationship="label">
                        <div>
                        <Image src={settings} alt="settings Icon" width={22} height={22} /> 
                        </div>
                    </Tooltip>    
                   
                </Tab>
               
                </TabList>
            </div>
        </div>
    )
}


export default SideBar;
